import { GeoState } from "../types/campaignTypes";

const GEO_PLACEHOLDER_NAMES = new Set(["unknown", "other"]);

export const isGeoPlaceholderState = (state: Pick<GeoState, "name">): boolean =>
  GEO_PLACEHOLDER_NAMES.has(state.name.trim().toLowerCase());

export const filterRealGeoStates = <T extends Pick<GeoState, "name">>(states: T[]): T[] =>
  states.filter((state) => !isGeoPlaceholderState(state));
